<template>
    <div class="alert col-md-6">
        <div class="alert__header">
            <svg class="alert__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54">
                <circle cx="27" cy="27" r="25" fill="none" stroke="#EB2626" stroke-miterlimit="10" stroke-width="4"></circle>
                <path fill="#EB2626" d="M29.83,27l6.72-6.72a1,1,0,0,0,0-1.41l-1.41-1.41a1,1,0,0,0-1.41,0L27,24.17l-6.72-6.72a1,1,0,0,0-1.41,0l-1.41,1.41a1,1,0,0,0,0,1.41L24.17,27l-6.72,6.72a1,1,0,0,0,0,1.41l1.41,1.41a1,1,0,0,0,1.41,0L27,29.83l6.72,6.72a1,1,0,0,0,1.41,0l1.41-1.41a1,1,0,0,0,0-1.41Z"></path>
            </svg>

        </div>

        <div class="alert__body  alert__body--space-top">
            <h3 class="alert__title">{{title}} {{status}}</h3>

            <div class="alert__text">{{ errorText }}</div>

            <div class="alert__actions">
                <a @click="redirectTo(action.routeName)" href="javascript:void(0)" class="btn  btn--danger">{{action.title}}</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AlertComponent",
        props: {
            title: {
                type: String,
                required: false,
                default: 'Ошибка',
            },
            text: {
                type: String,
                required: true
            },
            status: {
                type: Number,
                required: true,
                default: 403
            },
            action: {
                type: Object,
                default() {
                    return {
                        routeName: null,
                        title: 'Назад'
                    }
                }
            }
        },
        computed: {
            errorText() {
                return this.getTranslation( this.text );
            }
        },
        methods: {
            redirectTo( routeName ) {
                if ( routeName )
                    return this.$router.push( { name: routeName } ).catch(()=>{});
                return this.$router.go( -1 );
            }
        }
    }
</script>

<style scoped>

</style>
